import NewNotificationContainer from 'containers/Notifications/NewNotification'
import React from 'react'

const NewNotificationPage = () => <NewNotificationContainer />

export default NewNotificationPage
